import { render, staticRenderFns } from "./bottomPage.vue?vue&type=template&id=378618a8&scoped=true&"
import script from "./bottomPage.vue?vue&type=script&lang=js&"
export * from "./bottomPage.vue?vue&type=script&lang=js&"
import style0 from "./bottomPage.vue?vue&type=style&index=0&id=378618a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378618a8",
  null
  
)

export default component.exports